export const messages_kk = {
    nameEmpty: "Имя не может быть пустым",
    emailEmpty: "Адрес электронной почты не может быть пустым",
    emailNotValid: "Адрес электронной почты неверный. Пожалуйста, введите корректный адрес",
    locationEmpty: "Местоположение не может быть пустым",
    interests: "Выберите 3 группы интересов",
    profileSaved: "Информация о профиле сохранена",
    profilePic: "Изображение успешно сохранено ",
    addToFavorites: "Успешно добавлено в лист фаворитов",
    removeFromFavorites: "Успешно удалено из списка фаворитов"
};


// WEBPACK FOOTER //
// ./src/constants/messages_kk.js